import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { CONTACT } from "../data/siteData";

export const Header = () => {
  const [open, setOpen] = useState(false);

  const links = [
    { href: "#services", label: "Programs" },
    { href: "#how", label: "How It Works" },
    { href: "#about", label: "About" },
    { href: "#testimonials", label: "Stories" },
    { href: "#faq", label: "FAQ" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-b border-slate-200/80 shadow-[0_1px_0_0_rgba(10,31,61,0.04)]"
    >
      <div className="container-app flex h-20 items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3 font-heading"
          aria-label="J K Awesome Deeds home"
        >
          <span
            className="block h-12 w-12 rounded-full border-2 border-brand-navy shadow-sm bg-white shrink-0 overflow-hidden"
            aria-hidden="true"
          >
            <img
              src="/javier-headshot.jpg"
              alt=""
              className="h-full w-full object-cover"
            />
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="text-base font-bold tracking-tight text-brand-navy">
              J K Awesome Deeds <span className="text-brand-gold">LLC</span>
            </span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-brand-muted font-semibold">
              Florida · Real Estate Investors
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm font-medium text-brand-navy/80 hover:text-brand-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="header-phone"
            className="flex items-center gap-2 text-sm font-semibold text-brand-navy"
          >
            <Phone className="h-4 w-4" />
            {CONTACT.phone}
          </a>
          <a href="#lead-form" data-testid="header-cta" className="btn-primary">
            Get Help Now
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden p-2 text-brand-navy"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-slate-200"
        >
          <div className="container-app py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-brand-navy"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${CONTACT.phone}`}
              className="text-base font-semibold text-brand-navy flex items-center gap-2"
            >
              <Phone className="h-4 w-4" /> {CONTACT.phone}
            </a>
            <a
              href="#lead-form"
              onClick={() => setOpen(false)}
              className="btn-primary w-full"
            >
              Get Help Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
